import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/ServiceLayout.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
